import "./SelfFooter.scss"
import {ReactComponent as Logo} from "../../assets/self/logo-footer.svg"
import Rule from "../../assets/self/rule.svg"
import { useNavigate } from "react-router-dom"

export const SelfFooter = (props: {mobile: boolean}) => {
    const navigate = useNavigate()
    function contact() {
        navigate('/work')
    }

    return <div className={"self-footer" + (props.mobile ? " mobile" : "")}>
        <div className="logo-holder" style={ {backgroundImage: `url(${Rule})`} }>
            <Logo className="logo"/>
        </div>
        <div className="bottom">
            <div className="contact">
                <div className="contact-us" onClick={contact}>Contact Us</div>
                <div className="tell-us">
                    <div>Have a different kind of project?</div>
                    <div className="tell-us-cta" onClick={contact}>Tell us.</div>
                </div>
            </div>
            <div className="links">
                <a href="https://policies.spokenlayer.net/privacy-policy/" target="_blank" rel="noreferrer" className="privacy">Privacy</a>
                <div className="copyright">© SpokenLayer. {new Date().getFullYear()}</div>
            </div>
        </div>
    </div>
}